import SymptomInput from "../Main/SymptomsInput";

const BabySymptom = () => {
    return <SymptomInput whichOne={'Baby'} />;
  };
  
  export default BabySymptom;
  